import PromoterListApp from "promoter/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const promoterRoute: RouteObject = {
  path: "promoter",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: PromoterListApp,
  }]
};